import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Journal from "@/pages/Journal";
import Mood from "@/pages/Mood";
import Goals from "@/pages/Goals";
import Todos from "@/pages/Todos";
import Gratitude from "@/pages/Gratitude";
import Habits from "@/pages/Habits";
import Pricing from "@/pages/Pricing";
import PaymentResult from "@/pages/PaymentResult";
import Book from "@/pages/Book";
import Grief from "@/pages/Grief";
import Sober from "@/pages/Sober";
import Chronic from "@/pages/Chronic";
import Services from "@/pages/Services";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Services />} />
          <Route path="/about" element={<Landing />} />
          <Route path="/services" element={<Services />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/app" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/app/journal" element={<ProtectedRoute><Layout><Journal /></Layout></ProtectedRoute>} />
          <Route path="/app/mood" element={<ProtectedRoute><Layout><Mood /></Layout></ProtectedRoute>} />
          <Route path="/app/goals" element={<ProtectedRoute><Layout><Goals /></Layout></ProtectedRoute>} />
          <Route path="/app/todos" element={<ProtectedRoute><Layout><Todos /></Layout></ProtectedRoute>} />
          <Route path="/app/gratitude" element={<ProtectedRoute><Layout><Gratitude /></Layout></ProtectedRoute>} />
          <Route path="/app/habits" element={<ProtectedRoute><Layout><Habits /></Layout></ProtectedRoute>} />
          <Route path="/app/book" element={<ProtectedRoute><Layout><Book /></Layout></ProtectedRoute>} />
          <Route path="/app/grief" element={<ProtectedRoute><Layout><Grief /></Layout></ProtectedRoute>} />
          <Route path="/app/sober" element={<ProtectedRoute><Layout><Sober /></Layout></ProtectedRoute>} />
          <Route path="/app/chronic" element={<ProtectedRoute><Layout><Chronic /></Layout></ProtectedRoute>} />
          <Route path="/app/pricing" element={<ProtectedRoute><Layout><Pricing /></Layout></ProtectedRoute>} />
          <Route path="/payment-result" element={<ProtectedRoute><Layout><PaymentResult /></Layout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
